// --------------------------------------------------------
// COMPANY LIST ITEM - CompanyListItem
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useEffect, useState } from 'react'
import { ReactComponent as Cube } from '../../assets/imgs/cube.svg'
import { ListItemContainer, Table, TableData, Text, TextLink } from '../../components/UI/generalLayout/Layout.styled';
import ActivateInactivateModal from '../activateInactivateModal/ActivateInactivateModal';
import Colors from '../../constants/Colors';
import { StyledSwitch } from './CompanyListItem.styled';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import { ItemInfoContainer, MobileContainer, SwitchContainer, ViewEditContainer } from './CompanyListItemMobile.styled';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// COMPANY LIST ITEM INTERFACE
// --------------------------------------------------------

interface ICompanyListItem {
    name: string;
    cnpj: string;
    isActiveRegister: boolean;
    id: string;
    onEdit: any;
    onView: any;
    onOrpenConfig: any;
    onActivateInactivate: any;
    isCompany: boolean;
}
/**
/**
 * A component that renders a Company list item.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CompanyListItem = ({ name, cnpj, isActiveRegister, isCompany, id, onEdit, onView, onOrpenConfig, onActivateInactivate }: ICompanyListItem) => {
    // --------------------------------------------------------
    // COMPANY LIST ITEM PRIVATE DECLARATIONS
    // --------------------------------------------------------

    const [isActive, setIsActive] = useState(isActiveRegister)
    const [showModalInactivate, setShowModalInactivate] = useState(false)
    const { isMobile } = useResponsiveInfo()

    useEffect(()=>{
        setIsActive(isActiveRegister)
    }, [isActiveRegister])
    
    // --------------------------------------------------------

    const edit = ()=>{
        if(isActive){
            onEdit()
        }
    }

    const onChangeSwitchValue = (event: any) => {
        setShowModalInactivate(true)
     }

    const activateOrInactivateCompany = async (event: any)=>{
        try{
            onActivateInactivate(id, !isActive)
            setIsActive(prev=>!prev)
            setShowModalInactivate(false)
        }catch(error: any){
            
        }
    }
    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <ListItemContainer disabled={!isActive} style={{ marginTop: isMobile? 16 : 0}}>
                {!isMobile? (<Table>
                    <tbody>
                        <tr>
                            <TableData width={'7%'} style={{ verticalAlign:'middle' }}>
                                <Cube style={{ opacity: isActive? 1 : 0.4 }} />
                            </TableData>
                            <TableData width={'42%'}>
                                <Text bold={isActive} color={isActive? '':Colors.GRAY400}>{name}</Text>
                            </TableData>
                            <TableData width={'20%'}>
                                <Text color={isActive? '':Colors.GRAY400}>{cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')}</Text>
                            </TableData>
                            <TableData width={'8%'} alignRight={true}>
                                <TextLink 
                                    style={{ fontWeight: 'bold'}}
                                    color={Colors.SPM500}
                                    disabled={!isActive} 
                                    onClick={edit}>
                                        EDITAR
                                </TextLink>
                            </TableData>
                            <TableData width={'12%'} alignRight={true}>
                                <TextLink 
                                    style={{ fontWeight: 'bold'}}
                                    color={Colors.SPM500}
                                    onClick={onView}>
                                        VISUALIZAR
                                </TextLink>
                            </TableData>
                            <TableData width={'8%'} alignRight={true}>
                                <StyledSwitch 
                                    style={{ color: Colors.SPM600 }}
                                    checked={isActive}
                                    onChange={onChangeSwitchValue}
                                />
                            </TableData>
                        </tr>
                    </tbody>
                </Table>):
                (<MobileContainer>
                    <ItemInfoContainer>
                        <Text bold color={Colors.GRAY900}>{name}</Text>
                        <Text 
                            color={isActive? '#8D8D8D':Colors.GRAY400} 
                            style={{ fontSize: 14, marginTop: -6 }}
                        >
                            {cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')}
                        </Text>
                        <ViewEditContainer>
                            <TextLink 
                                disabled={!isActive} 
                                bold 
                                color={Colors.SPM500} 
                                style={{ fontSize: 12 }} 
                                onClick={edit}>
                                EDITAR
                            </TextLink>
                            <TextLink 
                                bold 
                                color={Colors.SPM500} 
                                style={{ fontSize: 12 }} 
                                onClick={onView}>
                                VISUALIZAR
                            </TextLink>
                        </ViewEditContainer>
                    </ItemInfoContainer>
                    <SwitchContainer>
                        <StyledSwitch
                                sx={{ width: 60 }}
                                style={{ color: Colors.SPM600, width: 45 }}
                                checked={isActive}
                                onChange={onChangeSwitchValue}
                            />
                        
                    </SwitchContainer>
                </MobileContainer>
            )}
            </ListItemContainer>

            <ActivateInactivateModal 
                isActivate={!isActive}
                visible={showModalInactivate}
                onCancel={() => { setShowModalInactivate(false); } }
                onConfirmCancellation={activateOrInactivateCompany} 
                ativarButtonMsg={`Ativar ${isCompany? 'empresa':'unidade'}`} 
                inativarButtonMsg={`Inativar ${isCompany? 'empresa':'unidade'}`} 
                modalMsg={`Tem certeza que deseja ${isActive? 'inativar':'ativar'} a ${isCompany? 'empresa':'unidade'} ${name}?`}                     
            />
        </>
    )
    // --------------------------------------------------------
}

export default CompanyListItem